import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SectionHeader from "@/components/SectionHeader";
import { SERVICES } from "@/data/services";

export default function ServicesSection() {
  return (
    <section className="relative bg-white py-24 sm:py-32" data-testid="services-section">
      <div className="container-x">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <SectionHeader
            overline="What we do"
            title={<>13 disciplines.<br />One <span className="text-emerald-brand">accountable</span> partner.</>}
            subtitle="From feasibility through commissioning, our integrated practices cover every consultancy your project needs — without hand-offs."
          />
          <Link
            to="/services"
            data-testid="services-section-view-all"
            className="inline-flex items-center gap-2 text-navy font-semibold text-xs tracking-[0.2em] uppercase border-b border-gold pb-1 hover:gap-3 transition-all whitespace-nowrap"
          >
            View all services <ArrowUpRight size={16} />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200">
          {SERVICES.map((s, i) => {
            const Icon = s.icon;
            return (
              <motion.div
                key={s.slug}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: (i % 3) * 0.05 }}
                className="group bg-white"
              >
                <Link
                  to={`/services/${s.slug}`}
                  data-testid={`service-card-${s.slug}`}
                  className="block p-8 h-full relative overflow-hidden"
                >
                  <div className="absolute inset-0 bg-navy translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-[cubic-bezier(0.77,0,0.175,1)]" />
                  <div className="relative">
                    <div className="flex items-center justify-between">
                      <div className="w-12 h-12 grid place-items-center border border-slate-200 text-emerald-brand group-hover:border-gold group-hover:text-gold transition-colors">
                        <Icon size={20} strokeWidth={1.5} />
                      </div>
                      <span className="overline text-slate-400 group-hover:text-gold transition-colors">
                        {String(i + 1).padStart(2, "0")}
                      </span>
                    </div>
                    <h3 className="mt-8 font-display font-bold text-xl text-navy group-hover:text-white transition-colors">
                      {s.title}
                    </h3>
                    <p className="mt-3 text-sm leading-relaxed text-slate-brand group-hover:text-white/75 transition-colors">
                      {s.short}
                    </p>
                    <div className="mt-8 inline-flex items-center gap-2 text-xs tracking-[0.2em] uppercase font-semibold text-emerald-brand group-hover:text-gold transition-colors">
                      Learn more <ArrowUpRight size={14} />
                    </div>
                  </div>
                </Link>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
